import React from 'react';
import { Menu } from '@uncinc/react-drupal-core';
import c from 'classnames';
import {
  CoreLink,
  Image
} from '../../../components';

import './style.scss';

const FooterMenuWithImages = ({ id, title, className }) => {
  return (
    <Menu id={id}>
      {(items) => {
        return (
          <div className={`FooterMenuWithImages ${className}`}>
            <div className="FooterMenuWithImages__title">{title}</div>
            <div className="FooterMenuWithImages__items">
              {items && items.map((item, index) => {
                const attrs = item.getIn(['link', 'options', 'attributes'], new Map());
                const href = item.getIn(['link', 'url'], '');
                const titleItem = item.getIn(['link', 'title'], 'Untitled');
                const image = item.getIn(['link', 'options', 'image', 'styles', 'partner_slider_teaser']);
                const itemClassName = c(attrs.get('class'), 'FooterMenuWithImages__items__icon');

                return (
                  <li key={`menu--${id}--menu-item-${titleItem}:${href}`} className={`${id} Menu`}>
                    <CoreLink
                      to={href}
                      target={attrs.get('target')}
                    >
                      <Image
                        src={image}
                        alt={titleItem}
                        includeWebP
                        className={itemClassName}
                      />
                    </CoreLink>
                  </li>
                );

              })}
            </div>
          </div>
        );
      }}
    </Menu>
  );
};

export default FooterMenuWithImages;
